<template>
  <div>
    <!-- <div>{{JSON.stringify(wayModel)}}</div> 
    <div>{{JSON.stringify(areaModel)}}</div>  -->
    <customFormCommonWay v-model="wayModel" @refresh="send"></customFormCommonWay>
    <customFormCommonArea v-model="areaModel" @refresh="send"></customFormCommonArea>
  </div>
</template>

<script> 
import customFormCommonWay from "@/components/customForm/common/custom-form-common-way/custom-form-common-way.vue";
import customFormCommonArea from "@/components/customForm/common/custom-form-common-area/custom-form-common-area.vue";
import { mapGetters } from "vuex";
export default {
  // 领域类别： 更多
  name: "custom-form-more",
  props: { 
    field: {
      type: Object,
      default: { extend: [], properties: [] }
    }
  }, 
  data() {
    return {
      propertyArr: [
        { List: [], TypeId: 0, Value: "授权渠道" },
        { List: [], TypeId: 1, Value: "招募地区" },
        { List: [], TypeId: 2, Value: "服务范围" },
        { List: [], TypeId: 3, Value: "代工品类" },
        { List: [], TypeId: 4, Value: "擅长内容" },
        { List: [], TypeId: 5, Value: "合作渠道" },
        { List: [], TypeId: 6, Value: "放大" }, 
        { List: [], TypeId: 11, Value: "合作客户" }, 
      ], 
      wayModel: { List: [], TypeId: 0, Value: "授权渠道"},
      areaModel: { List: [], TypeId: 2, Value: "招募地区"},
    };
  },
  components: { 
    customFormCommonWay,
    customFormCommonArea,
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }), 
  },
  created() { 
    this.init();
  },
  methods: { 
    init() {
      let data = this.field.properties; 
      let extend = this.field.extend;
      if (!data) return;
      data.forEach(c => {
        if (c.TypeId === 0) {
          this.wayModel.List = c.List;
        }
        if (c.TypeId === 1) {
          this.areaModel.List = c.List;
        }
      });  
    },
    send() {
      let model = [];
      let extend = [];
      if (this.wayModel && this.wayModel.List.length) {
        model.push(this.wayModel);
      }
      if (this.areaModel && this.areaModel.List.length) {
        model.push(this.areaModel);
      }   
      this.$emit("change", { extend: extend, properties: model });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
